// https://docs.piral.io/reference/documentation/loading-strategies

import { type LoadPiletsOptions, type PiletsLoaded, standardStrategy } from 'piral-base'
import type { Pilet, PiletMetadata } from 'piral-core'
import { environmentConfig } from '../environmentConfig'

const wrwksUpdatePiletName = __UPDATE_PILET__

const wrwksUpdatePiletFirst = (a: Pilet, b: Pilet) => {
  return a.name === wrwksUpdatePiletName ? -1 : b.name === wrwksUpdatePiletName ? 1 : 0
}

const feedUrl = environmentConfig.FEED_URL

export function piletRequester(): Promise<Array<PiletMetadata>> {
  if (__MOCK__) {
    console.warn('piral-app', 'pilet requester')
    return Promise.resolve([])
  }

  if (!globalThis.navigator.onLine) {
    console.debug('piral-app', 'pilet requester - offline. skip request')
    return Promise.resolve([])
  }

  return fetch(feedUrl)
    .then((res) => {
      return res.json()
    })
    .then((res) => res.items?.sort(wrwksUpdatePiletFirst))
    .catch((reason) => {
      console.error('piral-app', 'Error fetching pilets from url', feedUrl, reason)
      return []
    })
}

export function wrwksUpdateFirstLoadingStrategy(options: LoadPiletsOptions, cb: PiletsLoaded): PromiseLike<void> {
  const updatedOptions = { ...options, pilets: (options.pilets || []).sort(wrwksUpdatePiletFirst) }
  return standardStrategy(updatedOptions, cb)
}
